import React from 'react';
import { Page, Spin } from 'components';
import { useMixpanel } from 'hooks';
import { MixpanelPage } from 'hooks/useMixpanel/events';
import { useThirdPartyCookieCheck } from './hooks';
import ThirdPartyCookieMessage from './ThirdPartyCookieMessage';
import TableauDashboard from './TableauDashboard';

const MarketInsight: React.FC = () => {
  const [loading, isThirdPartyCookieEnabled] = useThirdPartyCookieCheck();
  useMixpanel({
    pageTracking: { pageName: MixpanelPage.AnalyticsShowingInsights },
  });

  const renderContent = () => {
    if (loading) return <Spin center size="large" />;
    if (!isThirdPartyCookieEnabled) return <ThirdPartyCookieMessage />;
    return <TableauDashboard />;
  };

  return (
    <Page type="filled" fillScreenHeight>
      {renderContent()}
    </Page>
  );
};

export default MarketInsight;
